import {useKeycloak} from '@react-keycloak/web';
import jwt from 'jwt-decode';
import {useEffect, useState} from 'react';
import Pusher from 'pusher-js';
import toast from 'react-hot-toast';
import {Button, Typography} from '@mui/material';
import {useAuthentication} from '../../auth/hooks/useAuthentication';
import {useSound} from '../../ringtones/useSound';

export const useNotificationPush = (callback, disabled = false) => {
  const {keycloak} = useKeycloak();

  const getUserId = () => {
    try {
      const decodedToken = jwt(keycloak.token);
      return decodedToken.sub;
    } catch {
      return null;
    }
  };

  const [notificationIds, setNotificationIds] = useState([]);
  const {isAuthenticated} = useAuthentication();

  const {playCallSound, playMessageSound} = useSound();

  const handleNextcloudNotification = function (data) {
    if (notificationIds.includes(data.message.id)) return;
    setNotificationIds([...notificationIds, data.message.id]);
    const userId = getUserId();
    if (userId === data.message.user) {
      callback && callback(data);
      if (data.message.object_type === 'chat') {
        playMessageSound();
        toast(
          t => (
            <>
              <Typography>
                Vous avez reçus un nouveau <b>message</b> &nbsp;
              </Typography>
              <Button
                variant="contained"
                onClick={() => {
                  toast.dismiss(t.id);
                  window.location.href = `${process.env.REACT_APP_NEXTCLOUD_BASE_URL}/apps/spreed/?callUser=${data.message.subject_parameters.userId}`;
                }}>
                Ouvrir la discussion
              </Button>
            </>
          ),
          {
            icon: '📬',
            duration: 10000,
          },
        );
      }

      if (data.message.object_type === 'call') {
        playCallSound();
        toast(
          t => (
            <>
              <Typography>
                Vous avez un <b>appel</b> en cours &nbsp;
              </Typography>
              <br />
              <Button
                variant="contained"
                onClick={() => {
                  toast.dismiss(t.id);
                  window.location.href = `${process.env.REACT_APP_NEXTCLOUD_BASE_URL}/apps/spreed/?callUser=${data.message.subject_parameters.callee}`;
                }}>
                Ouvrir l'appel
              </Button>
            </>
          ),
          {
            icon: '📞',
            duration: 10000,
          },
        );
      }
    }
  };

  const handlePushNotification = function (data) {
    callback && callback();
  };

  useEffect(() => {
    if (!isAuthenticated || disabled) return;

    const pusher = new Pusher(
      process.env.REACT_APP_PUSH_NOTIFICATIONS_APP_KEY,
      {
        cluster: process.env.REACT_APP_PUSH_NOTIFICATIONS_CLUSTER,
      },
    );

    const channel = pusher.subscribe('ohs-channel');
    channel.bind('new-notification', handleNextcloudNotification);
    channel.bind('push-notification', handlePushNotification);

    return () => {
      channel.unbind('new-notification', handleNextcloudNotification);
      channel.unbind('push-notification', handlePushNotification);
      pusher.unsubscribe('ohs-channel');
      pusher.disconnect();
    };
  }, []);
};
